<template>
  <ValidationObserver>
    <div id="login-view">
      <v-content>
        <v-container>
          <v-layout justify-center row wrap>
            <v-flex xs12 sm8 md6>
              <v-card
                max-width="800px"
                elevation=24
              >
                <v-toolbar dark color="primary">
                  <v-layout justify-center>
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                  </v-layout>
                </v-toolbar>

                <v-layout align-center justify-center row fill-height>
                  <router-link to="/">
                    <v-img
                      :src="require('../assets/fuzzcv-logo.png')"
                      contain
                      alt="fuzzcv curriculum vitae CV automatique en ligne"
                      width="300"
                      class="mt-3">
                    </v-img>
                  </router-link>
                </v-layout>
                <v-card-text class="subheading pt-5 pb-0">
                  {{ explainText }}
                </v-card-text>

                <v-form @submit.prevent>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex xs12>
                        <ValidationProvider name="email" rules="required|email">
                          <v-text-field
                            slot-scope="{
                                        errors,
                                        valid
                                        }"
                            :error-messages="errors"
                            :success="valid"
                            v-model="inputs.email"
                            :label="labelEmail"
                            required
                            prepend-icon="person"
                            name="username"
                          >
                          </v-text-field>
                        </ValidationProvider>
                      </v-flex>
                      <v-flex xs12>
                        <ValidationProvider name="mot de passe" rules="required">
                          <v-text-field
                            slot-scope="{
                                        errors,
                                        valid
                                        }"
                            :error-messages="errors"
                            :success="valid"
                            v-model="inputs.password"
                            :label="labelPassword"
                            type="password"
                            required
                            prepend-icon="lock"
                            name="password">
                          </v-text-field>
                        </ValidationProvider>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-layout wrap>
                      <v-flex xs12>
                        <div class="mb-3">
                          <v-alert v-show="error"
                                   :value="true"
                                   type="warning"
                          >
                            {{ raisonError }}
                          </v-alert>
                        </div>
                      </v-flex>

                      <v-layout align-center justify-space-between row fill-height>
                        <v-btn type="submit" color="info" @click="login(inputs)">{{ buttonLabel }}</v-btn>
                        <small>{{ required_fields }}</small>
                      </v-layout>

                      <v-flex xs12>
                        <div class="mt-3">
                          <div>
                            <router-link to="/register">{{ linkRegister }}</router-link>
                          </div>
                          <div>
                            <router-link to="/password_reset">{{ linkLostPass }}</router-link>
                          </div>
                        </div>

                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </div>
  </ValidationObserver>
</template>

<script>
 import {
   ValidationObserver,
   ValidationProvider,
   withValidation
 } from "vee-validate";
 import { mapActions, mapState } from 'vuex';

 export default {
   beforeRouteLeave(to, from, next) {
     this.resetERRORlogin();
     next();
   },
   components: {
     ValidationProvider,
     ValidationObserver
   },
   data() {
     return {
       title: "Identification",
       explainText: "Veuillez vous identifier, s'il vous plaît :",
       labelEmail: "Email*",
       labelPassword: "Mot de passe*",
       buttonLabel: "Se connecter",
       backToPageLabel: "Retourner à la page de login.",
       linkRegister: `Vous n'avez pas de compte? : créer un compte.`,
       linkLostPass: `Mot de passe perdu?`,
       required_fields: `*Champs requis`,
       inputs: {
         email: '',
         password: '',
       },

     };
   },
   computed: {
     ...mapState('auth', [
       'authenticating',
       'error',
       'token',
       'userMail',
       'raisonError',
     ]),
     ...mapState('signup', [
       'activationCompleted',
       'activationError',
       'activationLoading',
       'registrationCompleted',
       'registrationError',
       'registrationLoading',
       'registrationRaisonError',
     ]),
   },
   methods: {
     ...mapActions('auth', [
       'login',
       'resetERRORlogin',
     ]),
     ...mapActions('signup', [
       'clearRegistrationStatus',
     ]),


   },
   created: function() {
     // permet de réinitialiser le status lorque que l'on tape
     // l'url directement ou en cas de refresh.
     this.resetERRORlogin();
   },

 };
</script>

<style>
  #login-view {
    background-image: url('../assets/hands-joined-team.jpg');
    /* background-color: #8f2c2c; */
    height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
</style>
